export const ROUTER_LINKS = {
  login: 'login',
  library: 'library',
  test: 'test',
  edit_test: '/test/edit',
  questions: 'library/questions',
  add_candidate: '/test/add-candidate',
  view: '/test/view',
  manage_ongoing_test: '/test/manage-ongoing-test',
  manage_completed_test: '/test/manage-completed-test',
  view_test_score: '/test/view-test-score',
  question_wise_score: '/test/question-wise-score',
  view_candidate_images: '/test/view-candidate-images'
};

export const ASSETS = {
  wgLion: 'assets/WG-lion-graphic.png',
};

export const AUTH_STRINGS = {
  label: {
    email: 'Email',
    password: 'Password',
    login: 'Login',
    username: 'Username',
    login_sso_btn: 'Login using SSO'
  },
  idtoken: 'idtoken',
  usertoken: "usertoken"
};

export const AUTH_MESSAGES = {
  loginSuccessful: 'Logged In Successfully',
  invalidCredentials: 'Invalid Credentials',
  success: 'success',
  logoutSuccess: 'Logged out successfully',
};

export const OPTIONS = {
  option1: 'OPTION_1',
  option2: 'OPTION_2',
  option3: 'OPTION_3',
  option4: 'OPTION_4',
};

export const TEST_STATUS = {
  draft: 'DRAFT',
  scheduled: 'SCHEDULED',
  ongoing: 'ONGOING',
  complete: 'COMPLETE'
}

export const CORRECT_ANSWER = ['OPTION_1', 'OPTION_2', 'OPTION_3', 'OPTION_4'];

export const QUESTION_CARD_STRINGS = {
  updateQuestionTooltip: 'Update Question',
  deleteQuestionTooltip: 'Delete Question',
  addQuestionTooltip: 'Add Question',
  addQuestionToLibrary: 'Add Question To Library',
};

export const QUESTION_STRINGS = {
  selectTopic: 'Select a topic',
  selectLevel: 'Select a level',
  uploadTooltip: 'Upload Questions via Excel',
  addTooltip: 'Add Question',
  noQuestionsFound: 'No Questions found, Try another topic and level',
  label: {
    createQuestion: 'Create Question',
    addQuestion: 'Add Question',
    addCandidate: 'Add a Candidate',
    addBulkCandidate: 'Upload File',
    downloadSampleFile: 'Sample File',
    add_bulk_question: 'Add Bulk Questions',
    add_section: 'Add Section'
  },
  addCorrectAnswer: 'Add Correct Answer',
  correctAnswer: 'Correct Answer',
};

export const TOPIC_CARD_STRINGS = {
  updateTopicTooltip: 'Update Topic',
  deleteTopicTooltip: 'Delete Topic',
  success: 'success',
  error: 'error',
  confirm_delete: {
    message: 'Are you sure you want to delete this Topic',
    header: 'Confirm Delete',
  }
};

export const ERROR_MESSAGES = {
  conflict: 'Provide Unique Data',
  unprocessableContent: 'Pattern Validation Failed',
  genericError: 'Some error occurred',
  passwordValidationError: {
    character_length: 'Password must be at least 8 characters long.',
    upper_letter: 'Password must contain at least one uppercase letter.',
    digit_character: 'Password must contain at least one number.',
    special_character: 'Password must contain at least one special character.'
  }
};

export const MODE = {
  add: 'Add',
  bulkAdd: 'BulkAdd',
  update: 'Update',
  questionPool: 'QuestionPool',
  editTest: 'EditTest',
  listQuestion: 'ListQuestion',
  draftTest: 'DraftTest',
  scheduleTest: 'ScheduleTest',
};

export const TEST_QUESTION_POOL = {
  message: {
    addQuestionSuccessMessage: 'Question Added Successfully',
    success: 'success',
    addQuestionDuplicateMessage: 'Question Already Added',
    failed: 'danger',
    warning: 'warn'
  },
  header: {
    addQuestionToPool: 'Add Questions to Pool',
  },
};

export const ADD_CANDIDATE_POOL = {
  message: {
    success: 'success',
    failed: 'error',
    warning: 'warn',
    candidateAdded: 'Candidate Added Successfully',
    confirmCandidateUpdate: {
      header: 'Confirm Update',
      message: 'Are you sure you want to update candidate list'
    }
  },
  ui: {
    save: 'Save'
  }
}

export const BULK_ADD = {
  uploadFileCSV: 'Submitted file should be in XLSX format',
  processCSVFileSuccess: 'XLSX file processed successfully',
  processCSVFileFail: 'Failed to process XLSX file',
  invalidCSVLine: 'Invalid XLSX file format',
  invalidEmail: 'Invalid email format in XLSX file',
  invalidPhone: 'Invalid phone number format in XLSX file',
  invalidDataFormate: 'Invalid data formate in XLSX file'
}

export const TEST_LIST_POOL = {
  message: {
    confirmDelete: {
      message: 'Are you sure you want to delete this?',
      header: 'Confirm Delete',
    },
    confirmScheduleTest: {
      message: 'Are you sure you want to schedule this test?',
      header: 'Confirm Schedule Test'
    },
    confirmEvaluateTest: {
      message: 'Are you sure you want to evaluate this test?',
      header: 'Confirm Test Evaluation'
    },
    confirmEndTest: {
      message: 'Are you sure you want to end this test? Doing this will submit the test for all candidates and this action cannot be undone',
      header: 'Confirm Test End'
    }
  },
  toast: {
    success: 'success',
    failed: 'error',
    warning: 'warn',
    successDetail: 'Test deleted successfully.',
    failedDetail: 'Failed to delete Test.',
    success_evaluating: 'Test started evaluating.',
    fail_evaluating: 'Unable to start evaluation of test.',
    success_ending: 'Test ended successfully',
    fail_ending: 'Unable to end this test'
  },
  default_duration: 60,
  default_buffer: 30,
  ui: {
    no_test_found: 'No test found'
  }
}

export type ScoringMode = 'standard' | 'negative_marking';

export const TEST_SCORE = {
  scoringMode: {
    standard: 'standard' as ScoringMode,
    negative_marking: 'negative_marking' as ScoringMode,
    standardLabel: 'Standard',
    negativeMarkingLabel: 'Negative Marking',
  },
  message: {
    confirmEvaluateStandard: {
      message: 'Evaluate all candidates with standard scoring? Correct +1, wrong 0, unattempted 0.',
      header: 'Evaluate — Standard',
    },
    confirmEvaluateNegativeMarking: {
      message: 'Evaluate all candidates with negative marking? Correct +1, wrong -1, unattempted 0. Standard scores will be preserved.',
      header: 'Evaluate — Negative Marking',
    },
    negativeMarkingNotCalculated: 'Negative marking not calculated yet. Click Evaluate — Negative Marking.',
  },
  toast: {
    success_evaluating_standard: 'Standard evaluation started.',
    fail_evaluating_standard: 'Unable to start standard evaluation.',
    success_evaluating_negative: 'Negative marking evaluation started.',
    fail_evaluating_negative: 'Unable to start negative marking evaluation.',
  },
};

export const LIBRARY_QUESTION_POOL = {
  confirm_delete: {
    message: 'Are you sure you want to delete this question',
    header: 'Confirm Delete',
  },
  toast: {
    message: {
      question_delete_success: 'Question Deleted Successfully.',
      question_delete_fail: 'Question Deletion Failed.'
    },
    success: 'success',
    failed: 'error',
    warning: 'warn'
  },
  ui: {
    add_bulk_questions: 'Confirm Add Bulk Questions'
  }
}

export const MANAGE_TEST = {
  copy_text: {
    success: 'success',
    fail: 'warn',
    summery: 'Copied',
    detail: 'Text copied to clipboard'
  },
  candidate_test_active_status: {
    all: 'All',
    inactive: 'SCHEDULED',
    active: 'ACTIVE',
    complete: 'COMPLETED'
  },
  confirmChangeSystem: {
    message: 'Are you sure you want to allow candidate to change machine?',
    header: 'Confirm Change Machine Permission'
  },
  confirmEndTest: {
    message: 'Are you sure you want to end the test for this candidate? Doing this will submit the test and this action cannot be undone',
    header: 'Confirm End Test'
  },
  confirmEvaluateTest: {
    message: 'Are you sure you want to evaluate the candidate for this test? This action cannot be undone',
    header: 'Confirm Evaluate Candidate'
  },
  endTest: {
    success: 'Test ended for candidate successfully',
    fail: 'Unable to end test for candidate'
  },
  ui: {
    test_not_started: 'Not Started',
    test_not_submitted: 'Not Submitted'
  },
  default_test_submit_time: '1970-01-01 00:00:00'
}

export const TEST_EDIT = {
  test_name: 'Test Name',
  test_name_required: 'Test name is required.',
  test_duration: 'Test Duration (minutes)',
  test_duration_required: 'Duration is required.',
  test_duration_non_negative: 'Value of "Test Duration" must be non-negative.',
  status: 'Status',
  password: 'Password',
  password_required: 'Password is required.',
  start_date_time: 'Start Date and Time',
  start_date_time_required: 'Start date time is required.',
  end_date_time: 'End Date and Time',
  end_date_time_required: 'End date time is required.',
  start_end_time_order: 'Start date and time must be before end date and time.',
  enforce_camera: 'Enforce Camera',
  max_allowed_tab_switch: 'Maximum Allowed Tab Switch',
  max_allowed_tab_switch_required: 'Maximum Allowed Tab Switch is required',
  max_allowed_tab_switch_non_negative: 'Value of "Maximum Allowed Tab Switch" must be non-negative.',
  topic_wise_question_count: 'Topic wise Question Count',
  warning: 'warn',
  section_already_exist: 'Section with this name already exist.',
  section_contain_question: 'Section contain Questions so can not be deleted.',
  pooling_question_count_non_zero: 'pooling question count must be greater than zero.'
}

export const DEACTIVATE_MESSAGE = {
  unsaved_changes: 'Are you sure you want to leave? Changes you made may not be saved?'
}
